import { identidadeDaRede } from "../../helpers/canalDoTicket";

// Nome, glifo e cor de cada rede vêm de helpers/canalDoTicket — o mesmo mapa
// que marca o canal na lista de tickets. Duplicar aqui daria duas verdades
// sobre a mesma coisa, e a primeira rede nova entraria em só uma delas.
export { identidadeDaRede };

export const nomeDaRede = (plataforma) => identidadeDaRede(plataforma).rotulo;

// Só estas conversam. As demais entram como conta, mas o inbox unificado da
// Zernio não expõe mensagem direta nelas — dizer isso na tela evita conectar
// e ficar esperando conversa que não vem.
export const COM_INBOX = [
  "instagram",
  "facebook",
  "telegram",
  "whatsapp",
  "twitter",
  "x",
  "reddit",
  "bluesky",
  "discord",
  "slack"
];

// Quem aceita comentário em publicação. Fora daqui a aba de comentários não
// tem o que mostrar.
export const COM_COMENTARIOS = ["instagram", "facebook", "youtube", "tiktok"];

// Quem recebe avaliação de cliente.
export const COM_AVALIACOES = ["facebook", "googlebusiness"];
